module.exports = __webpack_public_path__ + "static/img/asset-404.6f8de056.svg";